import axios, { AxiosResponse } from 'axios'
import Container, { Service } from 'typedi'
import ErrorHandlerService from '@/modules/common/services/error-handler.service'
import IHttpClientPostParameters from '@/modules/common/contracts/http-client/http-client-post-parameters.interface'
import HttpClient from '@/modules/common/services/http-client.service'
import IHttpClientGetParameters from '@/modules/common/contracts/http-client/http-client-get-parameters.interface'
import IHttpClientDeleteParameters
  from '@/modules/common/contracts/http-client/http-client-delete-parameters.interface'

@Service()
export default class StaxBillService {
  public async submitCardDataToStaxBill (creditCardData: unknown): Promise<any> {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          // eslint-disable-next-line quote-props
          'Accept': 'application/json'
        }
      }
      const response = await axios.post(
        'https://payments.subscriptionplatform.com/api/paymentsv2',
        creditCardData,
        config
      )
      return response
    } catch (error) {
      Container.get(ErrorHandlerService).error(error)
    }
  }

  public async editStaxBillCard (creditCardData: unknown): Promise<any> {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          // eslint-disable-next-line quote-props
          'Accept': 'application/json'
        }
      }
      const response = await axios.put(
        'https://payments.subscriptionplatform.com/api/paymentsv2',
        creditCardData,
        config
      )
      return response
    } catch (error) {
      Container.get(ErrorHandlerService).error(error)
    }
  }

  public async createCustomer (): Promise<AxiosResponse<any>> {
    const httpParams: IHttpClientPostParameters = {
      url: '/user/me/stax-bill/create',
      requireToken: true
    }
    return await Container.get(HttpClient).post(httpParams)
  }

  public async deletePaymentMethod (uuid: string): Promise<AxiosResponse<any>> {
    const httpParams: IHttpClientDeleteParameters = {
      url: `user/me/stax-bill/payment-methods/${uuid}`,
      requireToken: true
    }
    return await Container.get(HttpClient).delete(httpParams)
  }

  public async getPaymentMethods (): Promise<AxiosResponse<any>> {
    const httpParams: IHttpClientGetParameters = {
      url: 'user/me/stax-bill/payment-methods',
      requireToken: true
    }
    return await Container.get(HttpClient).get(httpParams)
  }

  public async verifyPaymentMethod (payment_method_id: number, card_number: string, original_id?: number): Promise<AxiosResponse<any>> {
    const httpParams: IHttpClientPostParameters = {
      url: '/user/me/stax-bill/payment-method/verify',
      requireToken: true,
      payload: {
        payment_method_id,
        card_number,
        original_id
      }
    }
    return await Container.get(HttpClient).post(httpParams)
  }

  public async activateCustomer (): Promise<AxiosResponse<any>> {
    const httpParams: IHttpClientPostParameters = {
      url: '/user/me/stax-bill/activate',
      requireToken: true
    }
    return await Container.get(HttpClient).post(httpParams)
  }
}
